import React from 'react';
import { Create, SimpleForm, ReferenceInput, SelectInput, TextInput, BooleanInput, required, maxLength, Toolbar, SaveButton, useNotify, useRedirect } from 'react-admin';
import { Button } from '@mui/material';
import useAdmin from '../hooks/useAdmin';
import { ALL_CATEGORIES_FILTER } from '../utils/materialTypeFilters';

const CustomToolbar = () => {
    const redirect = useRedirect();
    const handleBack = () => {
        redirect('/subcategories');
    };
    return (
        <Toolbar>
            <SaveButton />
            <Button color="primary" onClick={handleBack} style={{ marginLeft: '10px' }}>Back</Button>
        </Toolbar>
    );
};

export const SubCategoryCreate = (props: any) => {
    const redirect = useRedirect();
    const notify = useNotify();
    const onSuccess = () => {
        notify('resources.subcategories.notification.created', {
            type: 'info',
            messageArgs: { smart_count: 1, name: 'SubCategory' },
        });
        redirect('/subcategories');
    };
    useAdmin();
    return (
        <Create {...props} mutationOptions={{ onSuccess: onSuccess }}>
            <SimpleForm
                toolbar={<CustomToolbar />}
                defaultValues={{ is_virgin: true, is_reprocessed: false }}
            >
                <ReferenceInput
                    source="parent_id"
                    reference="categories"
                    label="Category"
                    filter={ALL_CATEGORIES_FILTER}
                >
                    <SelectInput optionText="category_name" validate={[required()]}/>
                </ReferenceInput>
                <TextInput
                    source="sub_category_name"
                    label="Sub Category"
                    validate={[required(), maxLength(20)]}
                />
                <TextInput
                    source="sub_category_description"
                    label="Description"
                    validate={maxLength(50)}
                />
                <BooleanInput source="is_virgin" label="Virgin" defaultValue={true} />
                <BooleanInput source="is_reprocessed" label="Reprocessed" defaultValue={false} />
            </SimpleForm>
        </Create>
    );
};

export default SubCategoryCreate;
